import { render, staticRenderFns } from "./medalBox.vue?vue&type=template&id=31c0c8c2"
import script from "./medalBox.vue?vue&type=script&lang=js"
export * from "./medalBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports